import {SearchTermsEnum} from 'presentation/constants/searchTermsEnum';
import {getSpecialtyBySearch} from 'presentation/utils/GetSpecialtyBySearch';
import {useState} from 'react';
import {useSearchParams} from 'react-router-dom';
import {useTheme} from 'styled-components';

export function useTeleHealthCard() {
	const [searchParams] = useSearchParams();
	const {colors} = useTheme();
	const [openDetailsDrawerState, setOpenDetailsDrawerState] = useState(false);

	const specialtyBySearch = getSpecialtyBySearch({
		text: searchParams.get('q') || '',
	});

	const isHeadacheParams =
		specialtyBySearch?.toLocaleUpperCase() === SearchTermsEnum.DOR_DE_CABECA;

	const query = isHeadacheParams ? searchParams.get('q') || '' : specialtyBySearch;

	const handleOpenDetailsDrawer = () => {
		setOpenDetailsDrawerState(true);
	};

	const handleCloseDetailsDrawer = () => {
		setOpenDetailsDrawerState(false);
	};

	return {
		colors,
		query,
		openDetailsDrawerState,
		handleOpenDetailsDrawer,
		handleCloseDetailsDrawer,
	};
}
